import PropTypes from 'prop-types';

function PanelTab({ children }) {
  return children;
}

PanelTab.displayName = 'PanelTab';

PanelTab.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default PanelTab;
